function initMenu() {
	const $header = $('header');
	const $menuOverlay = $('.menu-overlay');
	const $menuInline = $('.menu-inline');
	const $menuToggle = $('.menu-toggle');
	const isOverlayMenu = $header.hasClass('header-menu-overlay');
	const isMobileMedia = window.matchMedia('(max-width: 1199.98px)');

	// Menu toggle
	$menuToggle.on('click', function () {
		$menuOverlay.fadeToggle(300);
		$menuOverlay.toggleClass('open');
		$menuInline.fadeToggle(300);
		$menuInline.toggleClass('open');
		$menuToggle.toggleClass('open');
		$header.toggleClass('open');
		closeSubmenus();
	});

	$('ul.header-main-menu li.menu-item-has-children > .menu-item-trigger').on('click', function (e) {
		e.preventDefault();
		const $this = $(this);
		const $li = $(this).parent();
		const $siblingList = $(this).siblings('.submenu-wrapper');
		const submenuLevel = $this.data('depth');

		//if (`${submenuLevel}` === '2' && !isMobileMedia.matches) return;

		if ($this.hasClass('active')) {
			$siblingList.stop().slideUp(300);
			$li.removeClass('open');
			$this.removeClass('active');
			$this.attr('aria-expanded', 'false');
		} else {
			closeSubmenus(submenuLevel);
			$siblingList.stop().slideToggle(300);
			$li.toggleClass('open');
			$this.toggleClass('active');
			$this.attr(
				'aria-expanded',
				$this.attr('aria-expanded') === 'true' ? 'false' : 'true',
			);
		}
	});

	// Reset inline menu on breakpoint change
	isMobileMedia.addEventListener('change', () => {
		if(!isOverlayMenu) {
			$menuInline.css('display', '');
			$menuInline.removeClass('open');
			closeMenu();
		}
	});

	clickedOutside('.menu-overlay', closeMenu, [
		'.menu-toggle',
		'.menu-inline',
		'.menu-overlay',
	]);
	clickedOutside('.menu-inline', closeMenu, [
		'.menu-toggle',
		'.menu-inline',
		'.menu-overlay',
	]);

	function closeMenu() {
		$menuOverlay.fadeOut(300);
		$menuOverlay.removeClass('open');
		if (isMobileMedia.matches) {
			$menuInline.fadeOut(300);
			$menuInline.removeClass('open');
		}
		$menuToggle.removeClass('open');
		$header.removeClass('open');
		closeSubmenus();
	}

	function closeSubmenus(dataLevel = 1) {
		$(`ul[data-level="${dataLevel}"] li.menu-item-has-children > .menu-item-trigger.active`).each(function () {
			$(this).siblings('.submenu-wrapper').stop().slideToggle(300, function () {
				$(this).css('display', '');
			});
			$(this).removeClass('active');
			$(this).attr('aria-expanded', 'false');
			$(this).parent().removeClass('open');
		});
	}

}
